import {BrowserRouter, Route, Routes} from "react-router-dom";
import {RouterType} from "./constants/types";
import PeakPage from "./components/pages/PeakPage";
import LinkPage from "./components/pages/LinkPage";
import AllDevicePage from "./components/pages/AllDevicePage";
import ShowcasePage from "./components/pages/ShowcasePage";
import MainPage from "./components/pages/MainPage";
import {LogPage} from "./components/pages/LogPage";
import {LotteSuperAdminPage} from "./components/pages/LotteSuperAdminPage";
import {PositionSettingPage} from "./components/pages/PositionSettingPage";

const Router = (props: RouterType) => {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/peak" element={<PeakPage render={props.render} />} />
                <Route path="/link" element={<LinkPage render={props.render} />} />
                <Route path="/device" element={<AllDevicePage render={props.render} />} />
                <Route path="/showcase" element={<ShowcasePage render={props.render} />} />
                <Route path={"/log"} element={<LogPage />} />
                <Route path={"/lottesuper"} element={<LotteSuperAdminPage />} />
                <Route path={"/lottesuper/position"} element={<PositionSettingPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
